module.exports = __webpack_public_path__ + "img/erweima_emof.5363bf81.jpg";